'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var localityLabel = exports.localityLabel = function localityLabel(country) {
  switch (country) {
    case 'au':
    case 'nz':
      return 'Town/Suburb';
    case 'ie':
      return 'Town/City';
    case 'uk':
    case 'gb':
      return 'Town';
    default:
      return 'City';
  }
};

var regionLabel = exports.regionLabel = function regionLabel(country) {
  switch (country) {
    case 'uk':
    case 'gb':
    case 'ie':
      return 'County';
    case 'ca':
      return 'Province';
    default:
      return 'State';
  }
};

var postCodeLabel = exports.postCodeLabel = function postCodeLabel(country) {
  switch (country) {
    case 'us':
      return 'Zip Code';
    default:
      return 'Postcode';
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/utils/address/index.js
// module id = 1470
// module chunks = 0